import {
  Card,
  Title,
  Image,
  Text,
  Button,
  ButtonGroup,
  Stack,
  Grid,
} from "@mantine/core";
import { DateTime } from "luxon";
import { useNavigate } from "react-router";
import { trackEvent } from "../analytics.ts";

export const Vortrag = (props: {
  event: {
    id: string;
    speaker: string;
    title: string;
    startDate: string;
    description: string;
    imageUrl: string;
    freeSeats: boolean;
    endOfRegistration: string;
  };
}) => {
  const navigate = useNavigate();

  const date = DateTime.fromISO(props.event.startDate)
    .setLocale("de")
    .toLocaleString({
      weekday: "short",
      day: "2-digit",
      month: "long",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });

  return (
    <Card padding="lg" radius="xl" withBorder>
      <Grid gap="xl" align="flex-start">
        <Grid.Col span={{ base: 12, sm: 5 }}>
          <Image
            src={props.event.imageUrl}
            radius="lg"
            style={{ width: "100%", aspectRatio: "16 / 9" }}
            alt="Vortrag Bild"
          />
        </Grid.Col>

        <Grid.Col span={{ base: 12, sm: 7 }}>
          <Stack>
            <Title c="#303030" order={2}>
              {props.event.title}
            </Title>
            <Text fw="bold" c="dimmed">
              {date} Uhr
              <br />
              {props.event.speaker}
            </Text>
            <Text>{props.event.description}</Text>
            <ButtonGroup mt="sm">
              {new Date() > new Date(props.event.endOfRegistration) ? (
                <Button color="#e2ba70" size="md" radius="xl" disabled>
                  Anmeldung nicht mehr möglich
                </Button>
              ) : props.event.freeSeats ? (
                <Button
                  color="#e2ba70"
                  size="md"
                  radius="xl"
                  onClick={() => {
                    trackEvent("vortrag-gewaehlt", {
                      vortragId: props.event.id,
                      titel: props.event.title,
                    });
                    navigate(`/anmelden/${props.event.id}`);
                  }}
                >
                  Zum Vortrag anmelden
                </Button>
              ) : (
                <Button color="#e2ba70" size="md" radius="xl" disabled>
                  Keine freien Plätze
                </Button>
              )}
            </ButtonGroup>
          </Stack>
        </Grid.Col>
      </Grid>
    </Card>
  );
};
